import { Message } from 'element-ui'
// 扁平化数组
export function flattenArr(arr) {
  const resultOnceArr = []
  // eslint-disable-next-line
  const flatten = function (val) {
    resultOnceArr.push(val)
    if (val.children && val.children.length > 0) {
      val.children.map(item => {
        flatten(item)
      })
    }
  }
  arr.map(item => {
    flatten(item)
  })
  return resultOnceArr
}
/**
 * 对象数组根据属性返回是否拥有此对象
 * arr: 需要操作数组
 * attr： 属性名
 * val：值
 * 返回true/false
 */
export function arrHasAttr(arr, attr, val) {
  let flag = false
  arr.map(item => {
    if (item[attr] === val) {
      flag = true
    }
  })
  return flag
}
// 数组根据某一属性去重
/**
 * @param {Array} arr 数组对象
 * @param {String} key 属性
 */
export function arrReduce(arr, key) {
  if (key) {
    const obj = {}
    const newArr = arr.reduce((cur, next) => {
      obj[next[key]] ? '' : obj[next[key]] = true && cur.push(next)
      return cur
    }, [])
    return newArr
  } else {
    return [...new Set(arr)]
  }
}
// 删除掉对象中值为空的项
/**
 * @param {Object} params 对象
 */
export function delObjectKey(params) {
  // 深拷贝对象，避免影响页面显示
  const obj = JSON.parse(JSON.stringify(params))
  Object.keys(obj).forEach(item => {
    if (obj[item] === '' || obj[item] === undefined || obj[item] === null || obj[item] === 'null' || obj[item].length === 0) delete obj[item]
  })
  return obj
}
// 获取地址栏参数
export function urlArgs(obj, bool) { // 该方法使用说明在底部
  const urlObj = {}
  let str = location.href
  if (str && str.indexOf('?') !== -1) {
    // 获取地址栏参数
    const num = str.indexOf('?')
    str = str.substr(num + 1)
    const arr = str.split('&')
    arr.forEach(item => {
      const query = item.split('=')
      // urlObj[query[0]] = query[1] && JSON.parse(decodeURI(query[1]))
      urlObj[query[0]] = decodeURI(query[1])
    })
    // 设置回调值
    if (!obj) {
      return urlObj
    }
    if (typeof (obj) === 'string') { // obj为字符串时，bool表示希望得到的值类型：Number（数字类型）、String（字符串类型），默认 String
      if (bool) {
        if (urlObj[obj]) {
          return bool(urlObj[obj])
        } else {
          return bool('')
        }
      } else {
        return urlObj[obj] || ''
      }
    } else { // 参数为数组对象，bool表示 是否 仅return传递的参数；true：表示仅 return 传递的参数，false 表示处理传递的参数并返回所有地址栏参数，默认false
      if (bool) { // 仅return传递的参数
        const onlyObj = {}
        obj.forEach(key => {
          if (typeof (key.name) === 'string') { // name为字符串
            if (urlObj[key.name] !== undefined) {
              if (key.type) {
                onlyObj[key.name] = key.type(urlObj[key.name])
              } else {
                onlyObj[key.name] = urlObj[key.name]
              }
            }
          } else { // name为数组
            onlyObj[key.concat] = []
            key.name.forEach(item => {
              if (urlObj[item]) {
                onlyObj[key.concat].push(urlObj[item])
              }
            })
          }
        })
        return onlyObj
      } else { // 非仅return传递的参数
        obj.forEach(key => {
          if (typeof (key.name) === 'string') { // name为string
            if (urlObj[key.name] !== undefined) {
              if (key.type) {
                urlObj[key.name] = key.type(urlObj[key.name])
              } else {
                urlObj[key.name] = urlObj[key.name]
              }
              if (key.delete) {
                delete urlObj[key.name]
              }
            }
          } else { // name为数组
            urlObj[key.concat] = []
            key.name.forEach(item => {
              if (urlObj[item]) {
                if (key.type) {
                  urlObj[key.concat].push(key.type(urlObj[item]))
                } else {
                  urlObj[key.concat].push(urlObj[item])
                }
              }
            })
          }
        })
        return urlObj
      }
    }
  } else {
    if (typeof (obj) === 'string') {
      return ''
    } else {
      return {}
    }
  }
}

/** 图片压缩 返回base64 */
export function dealImage(path, obj, callback) {
  var img = new Image()
  img.src = path
  // eslint-disable-next-line
  img.onload = function () {
    var that = this
    // 默认按比例压缩
    let w = that.width
    let h = that.height
    const scale = w / h
    w = w || obj.width
    h = (w / scale) || obj.height
    var quality = 0.5 // 默认图片质量为0.9
    // 生成canvas
    var canvas = document.createElement('canvas')
    var ctx = canvas.getContext('2d')
    // 创建属性节点
    var anw = document.createAttribute('width')
    anw.nodeValue = w
    var anh = document.createAttribute('height')
    anh.nodeValue = h
    canvas.setAttributeNode(anw)
    canvas.setAttributeNode(anh)
    ctx.drawImage(that, 0, 0, w, h)
    // 图像质量
    if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
      quality = obj.quality
    }
    // quality值越小，所绘制出的图像越模糊
    var base64 = canvas.toDataURL('image/jpeg', quality)
    // 回调函数返回base64的值
    callback(base64)
  }
  img.onerror = (e) => {
    callback('')
  }
}

/** base64转file
 * filename图片的名字，dataurl是base64地址
 */
export function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?)/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

// 获取当前日期 yyyy-MM-DD hh:mm:ss
export function getNowFormatDate() {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth() + 1
  var day = now.getDate()
  var hh = now.getHours()
  var mm = now.getMinutes()
  var ss = now.getSeconds()
  var clock = year + '-'
  if (month < 10) {
    clock += '0'
  }
  clock += month + '-'
  if (day < 10) {
    clock += '0'
  }
  clock += day + ' '
  if (hh < 10) {
    clock += '0'
  }
  clock += hh + ':'
  if (mm < 10) clock += '0'
  clock += mm + ':'
  if (ss < 10) clock += '0'
  clock += ss
  return clock
}
/**
 * 判断数据是否是json字符串
 * @param {String} str
 */
export function isJson(str) {
  if (!str) return false
  if (typeof str === 'string') {
    try {
      JSON.parse(str)
      return true
    } catch (e) {
      return false
    }
  } else {
    return false
  }
}
/**
 * 文件下下载
 * 接口返回数据
 */
export function downLoad(res) {
  const reader = new FileReader()
  // let fileNames = res.headers['content-disposition'] //获取到Content-Disposition;filename
  // let regFileNames = fileNames.match(/=(.*)$/)[2]
  // eslint-disable-next-line
  reader.onloadend = function (event) {
    // event 就是你要的返回内容
    // 因为返回的报错格式是字符串，手动转换成对象，转换成功表示请求失败
    // 转换失败就意味着你拿到的result是文件流，那么直接手动下载就好
    try {
      const data = JSON.parse(event.target.result)
      Message({
        message: data.message || '服务器异常',
        type: 'error',
        duration: 3 * 1000
      })
    } catch (err) {
      const arr = res.headers['content-disposition'].split(';')
      const temp = arr[arr.length - 1].split('filename=')[1].split('.')[0]
      // const iconv = require('iconv-lite')
      // iconv.skipDecodeWarning = true
      // const fileName = iconv.decode(temp, 'utf-8')
      const fileName = decodeURI(temp) + '.' + arr[arr.length - 1].split('filename=')[1].split('.')[1]
      const link = document.createElement('a')
      const blob = new Blob([res.data], { type: 'application/octet-stream' })
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      link.setAttribute('download', fileName.replace(new RegExp('"', 'g'), '')) // 给下载后的文件命名
      document.body.appendChild(link)
      link.click() // 点击下载
      document.body.removeChild(link) //  完成移除元素
      window.URL.revokeObjectURL(link.href) // 释放blob对象
    }
  }
  reader.readAsText(res.data)
}
/**
 * 16进制颜色（带透明度）转rgba
 * colors 16进制颜色（带透明度）
 */
export function colorRgba(colors) {
  if (!colors) return '176,179,183,0.4'
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  const color = colors.slice(0, -2).toLowerCase()
  const opacity = colors.slice(-2) / 100
  if (reg.test(color)) {
    // 处理六位的颜色值，转为RGB
    const colorChange = []
    for (let i = 1; i < 7; i += 2) {
      colorChange.push(parseInt('0x' + color.slice(i, i + 2)))
    }
    return colorChange.join(',') + ',' + opacity
  } else {
    return color
  }
}
/**
 * 校验手机号、固话号
 * phone strin
 */
export function checkInvoiceMobile(receiver_mobile) {
  const isPhone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
  const isMobile = /^(?:(?:0\d{2,3})-)?(?:\d{7,8})(-(?:\d{3,}))?$/
  // 如果为1开头则验证手机号码
  if (receiver_mobile.substring(0, 1) === '1') {
    if (!isPhone.test(receiver_mobile)) {
      return false
    }
  } else if (receiver_mobile.substring(0, 1) === '0') {
    // 如果为0开头则验证固定电话号码
    if (!isMobile.test(receiver_mobile)) {
      return false
    }
  } else {
    // 否则全部不通过
    return false
  }
  return true
}
/**
 * 校验身份证
 * @param {string} code
 * @returns
 */
export function IdCodeValid(code) {
  // 身份证号合法性验证
  // 支持15位和18位身份证号
  // 支持地址编码、出生日期、校验位验证
  const city = { 11: '北京', 12: '天津', 13: '河北', 14: '山西', 15: '内蒙古', 21: '辽宁', 22: '吉林', 23: '黑龙江 ', 31: '上海', 32: '江苏', 33: '浙江', 34: '安徽', 35: '福建', 36: '江西', 37: '山东', 41: '河南', 42: '湖北 ', 43: '湖南', 44: '广东', 45: '广西', 46: '海南', 50: '重庆', 51: '四川', 52: '贵州', 53: '云南', 54: '西藏 ', 61: '陕西', 62: '甘肃', 63: '青海', 64: '宁夏', 65: '新疆', 71: '台湾', 81: '香港', 82: '澳门', 91: '国外 ' }
  let row = {
    'pass': true,
    'msg': '验证成功'
  }
  if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(code)) {
    row = {
      'pass': false,
      'msg': '身份证号格式错误'
    }
  } else if (!city[code.substr(0, 2)]) {
    row = {
      'pass': false,
      'msg': '身份证号地址编码错误'
    }
  } else {
    // 18位身份证需要验证最后一位校验位
    if (code.length === 18) {
      code = code.split('')
      // ∑(ai×Wi)(mod 11)
      // 加权因子
      const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      // 校验位
      const parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
      let sum = 0
      let ai = 0
      let wi = 0
      for (let i = 0; i < code.length - 1; i++) {
        ai = code[i]
        wi = factor[i]
        sum += ai * wi
      }
      if (parity[sum % 11] + '' !== code[code.length - 1].toUpperCase()) {
        row = {
          'pass': false,
          'msg': '身份证号校验错误'
        }
      }
    }
  }
  return row
}
/**
* 根据身份证获取出生日期
* @param idCard
*/
export function getBirth(idCard) {
  let birthday = ''
  if (idCard !== null && idCard !== '') {
    if (idCard.length === 15) {
      birthday = '19' + idCard.slice(6, 12)
    } else if (idCard.length === 18) {
      birthday = idCard.slice(6, 14)
    }
    birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-')
    // 通过正则表达式来指定输出格式为:1990-01-01
  }
  return birthday
}
/**
* 根据身份证获取性别
* @param idCard
*/
export function getSex(idCard) {
  let sexStr = ''
  if (parseInt(idCard.slice(-2, -1)) % 2 === 1) {
    sexStr = '男'
  } else {
    sexStr = '女'
  }
  return sexStr
}
/**
* 对象转拼接字符串
* obj: 对象
*/
export function queryTostr(obj) {
  const params = []
  Object.keys(obj).forEach((key) => {
    let value = obj[key]
    // 如果值为undefined我们将其置空
    if (typeof value === 'undefined') {
      value = ''
    }
    // 对于需要编码的文本（比如说中文）我们要进行编码
    params.push([key, encodeURIComponent(value)].join('='))
  })
  return params.join('&')
}
/**
 * 获取当前年月
 */
export function getCUrrentYearMonth() {
  const myDate = new Date()
  const year = myDate.getFullYear()
  const month = myDate.getMonth()
  let m = month + 1
  if (m.toString().length === 1) {
    m = '0' + m
  }
  return year + '-' + m
}
/**
 * 阿拉伯数字转中文
 * num 入参阿拉伯数字
 */
export function Arabia_To_SimplifiedChinese(Num) {
  for (let i = Num.length - 1; i >= 0; i--) {
    Num = Num.replace(',', '') // 替换Num中的“,”
    Num = Num.replace(' ', '') // 替换Num中的空格
  }
  if (isNaN(Num)) { // 验证输入的字符是否为数字
    return;
  }
  // 字符处理完毕后开始转换，采用前后两部分分别转换
  const part = String(Num).split('.');
  let newchar = '';
  // 小数点前进行转化
  for (let i = part[0].length - 1; i >= 0; i--) {
    if (part[0].length > 10) {
      // alert('位数过大，无法计算');
      return '';
    } // 若数量超过拾亿单位，提示
    let tmpnewchar = ''
    const perchar = part[0].charAt(i);
    switch (perchar) {
      case '0': tmpnewchar = '零' + tmpnewchar; break;
      case '1': tmpnewchar = '一' + tmpnewchar; break;
      case '2': tmpnewchar = '二' + tmpnewchar; break;
      case '3': tmpnewchar = '三' + tmpnewchar; break;
      case '4': tmpnewchar = '四' + tmpnewchar; break;
      case '5': tmpnewchar = '五' + tmpnewchar; break;
      case '6': tmpnewchar = '六' + tmpnewchar; break;
      case '7': tmpnewchar = '七' + tmpnewchar; break;
      case '8': tmpnewchar = '八' + tmpnewchar; break;
      case '9': tmpnewchar = '九' + tmpnewchar; break;
    }
    switch (part[0].length - i - 1) {
      case 0: break;
      case 1: if (perchar !== 0) tmpnewchar = tmpnewchar + '十'; break;
      case 2: if (perchar !== 0) tmpnewchar = tmpnewchar + '百'; break;
      case 3: if (perchar !== 0) tmpnewchar = tmpnewchar + '千'; break;
      case 4: tmpnewchar = tmpnewchar + '万'; break;
      case 5: if (perchar !== 0) tmpnewchar = tmpnewchar + '十'; break;
      case 6: if (perchar !== 0) tmpnewchar = tmpnewchar + '百'; break;
      case 7: if (perchar !== 0) tmpnewchar = tmpnewchar + '千'; break;
      case 8: tmpnewchar = tmpnewchar + '亿'; break;
      case 9: tmpnewchar = tmpnewchar + '十'; break;
    }
    newchar = tmpnewchar + newchar;
  }
  // 替换所有无用汉字，直到没有此类无用的数字为止
  while (newchar.search('零零') !== -1 || newchar.search('零亿') !== -1 || newchar.search('亿万') !== -1 || newchar.search('零万') !== -1) {
    newchar = newchar.replace('零亿', '亿');
    newchar = newchar.replace('亿万', '亿');
    newchar = newchar.replace('零万', '万');
    newchar = newchar.replace('零零', '零');
  }
  // 替换以“一十”开头的，为“十”
  if (newchar.indexOf('一十') === 0) {
    newchar = newchar.substr(1);
  }
  // 替换以“零”结尾的，为“”
  if (newchar.lastIndexOf('零') === newchar.length - 1) {
    newchar = newchar.substr(0, newchar.length - 1);
  }
  return newchar;
}
